<div class="wrapper">
    <div class="abs-center wd-xxl">
        <!-- START card-->
        <div class="text-center mb-4">
            <div class="text-lg mb-3">
                <em class="fa fa-question fa-2x text-muted"></em>
            </div>
            <div class="text-lg">{{ 'ROUTES.PAGES.404.TITLE' | translate }}</div>
        </div>
        <ul class="list-inline text-center">
            <li class="list-inline-item">
                <a class="text-muted login-link" [routerLink]="'/'">{{ 'ROUTES.PAGES.404.LINK.LOGIN' | translate }}</a>
            </li>
        </ul>
    </div>
</div>
